import React, { useEffect, useState } from 'react';

interface AiThinkingProps {
    text?: string;
    text2?: string;
    textClassName?: string;
    thinkingDotsCustomeClass?: string;
}

const FADE_DURATION = 300; // ms

const AiThinking: React.FC<AiThinkingProps> = ({ text, text2, textClassName, thinkingDotsCustomeClass }) => {
    const phrases = ['Thinking', text || 'Analyzing your request…', ...(text2 ? [text2] : [])];
    const [index, setIndex] = useState(0);
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setInterval(() => {
            // Fade out
            setVisible(false);
            setTimeout(() => {
                setIndex((prev) => (prev + 1) % phrases.length);
                // Fade in
                setVisible(true);
            }, FADE_DURATION);
        }, 3000);

        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [phrases.length]);

    return (
        <div className="flex gap-x-2 ai-sender">
            <span className=" agent-thinking-animation-wrap ">
                <span className={`agent-thinking-animation-dots ${thinkingDotsCustomeClass}`}>
                    <span className="agent-thinking-animation-dot" aria-hidden="true"></span>
                    <span className="agent-thinking-animation-dot" aria-hidden="true"></span>
                    <span className="agent-thinking-animation-dot" aria-hidden="true"></span>
                    <span className="agent-thinking-animation-dot" aria-hidden="true"></span>
                </span>
            </span>
            <p
                className={`text-gray500 text-xs leading-[1.5] font-normal agent-thinking-animation ${textClassName}`}
                style={{ transition: `opacity ${FADE_DURATION}ms ease`, opacity: visible ? 1 : 0 }}
                aria-label="Agent is thinking"
            >
                {phrases[index]}
            </p>
        </div>
    );
};

export default AiThinking;
